<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-main">
        <!-- Left Side: Brand & CTA -->
        <div class="footer-left">
          <div class="logo">
            <img src="../assets/无国界logo.png " alt="AI Without Borders Logo" style="width: 200px; height: 100px;">
          </div>
          <p class="tagline">We build better AI solutions for global innovation.</p>
        
        </div>

        <!-- Right Side: Content -->
        <div class="footer-right">
          <div class="commitment-text">
            <p>
              AI Without Borders is committed to helping our clients build better future through artificial intelligence and borderless innovation.
              <router-link to="/login" style="text-decoration: underline; color: #6CC3D5; margin-left: 15px; font-weight: 600;">Auditor Login</router-link>
            </p>
          </div>
          
          <div class="info-columns">
            <!-- Column 1: Contact -->
            <div class="info-col">
              <h3>Contact Us</h3>
              <p><a href="mailto:info@aiwithoutborders.co">info@aiwithoutborders.co</a></p>
              <p><a href="tel:+6512345678"></a></p>
            </div>
            <!-- Column 2: Location -->
            <div class="info-col">
              <h3>Our Location</h3>
              <p>C1-0507, Jalan Indah 12/11</p>
              <p>Taman Bukit Indah</p>
              <p>79100 Iskandar Puteri, Johor, Malaysia</p>
              <br>
              <p>50 Nanyang Ave, N4</p>
              <p>B2a-02, Singapore 639798</p>
            </div>
            <!-- Column 3: Follow Us -->
            <div class="info-col">
              <h3>Follow Us</h3>
              <div class="social-icons">
                <a href="https://www.linkedin.com/company/ai-without-borders-10752/" target="_blank" class="social-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" width="18" height="18"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"/></svg>
                </a>
                <a href="https://x.com/aiwithoutborder" target="_blank" class="social-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" width="18" height="18"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>
                </a>
                <a href="https://www.facebook.com/profile.php?id=61584532876000" target="_blank" class="social-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor" width="18" height="18"><path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"/></svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="bottom-links">
     
        </div>
        <div class="copyright">
          <p>&copy; 2025 AI Without Borders. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>

<style scoped>
.footer {
  background-color: #000;
  padding: 4rem 0 2rem;
  width: 100%;
  font-family: 'PingFangSC', sans-serif;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.footer-main {
  display: flex;
  flex-wrap: wrap;
  gap: 4rem;
  margin-bottom: 4rem;
}

/* Left Side */
.footer-left {
  flex: 1;
  min-width: 250px;
  max-width: 400px;
  text-align: left;
}

.logo img {
  height: 48px;
  width: auto;
  margin-bottom: 1.5rem;
}

.tagline {
  color: #ccc;
  font-size: 1.1rem;
  margin-bottom: 2rem;
  line-height: 1.5;
  font-weight: 500;
}

.cta-button {
  display: inline-block;
  background-color: #6CC3D5;
  color: #000;
  padding: 0.8rem 2rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  transition: background-color 0.3s, transform 0.2s;
}

.cta-button:hover {
  background-color: #5ab0c2;
  transform: translateY(-2px);
}

/* Right Side */
.footer-right {
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  text-align: left;
}

.commitment-text p {
  font-size: 1.2rem;
  line-height: 1.6;
  color: #fff;
  max-width: 800px;
  font-weight: 500;
}

.info-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 5px;
}

.info-col h3 {
  font-size: 1rem;
  color: #888888;
  margin-bottom: 1rem;
  font-weight: 600;
}

.info-col p, .info-col a {
  color: #fff;
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
  text-decoration: none;
  font-weight: 600;
}

.info-col a:hover {
  color: #6CC3D5;
}

/* Social Icons */
.social-icons {
  display: flex;
  gap: 0.8rem;
  flex-wrap: nowrap;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: #294c51;
  border-radius: 50%;
  color: #fff;
  text-decoration: none;
  transition: background-color 0.3s;
  font-size: 0.9rem;
}

.social-icon:hover {
  background-color: #6CC3D5;
  color: #000;
}

/* Footer Bottom */
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
  font-size: 0.8rem;
  color: #666;
  border-top: 1px solid #333;
}

.bottom-links a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s;
}

.bottom-links a:hover {
  color: #fff;
}

@media (max-width: 900px) {
  .footer-main {
    flex-direction: column;
    gap: 3rem;
  }
  
  .footer-left {
    max-width: 100%;
  }
  
  .info-columns {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
}
</style>